module.exports = __webpack_public_path__ + "img/profile_edit.df2456e1.svg";